import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components';

const NetlifyContentStyle = styled.div`
  {
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.94;
    letter-spacing: normal;
    color: #000000;
    width: 100%;
    margin-bottom: 10px;

    p {
      margin-top: 20px
    }
  }
  

`

export const HTMLContent = ({ content, className }) => (
  <NetlifyContentStyle>
    <div dangerouslySetInnerHTML={{ __html: content }} />
  </NetlifyContentStyle>
)

const Content = ({ content, className }) => (
  <div className={className}>{content}</div>
)

// Content.propTypes = {
//   content: PropTypes.string,
//   className: PropTypes.string,
// }

HTMLContent.propTypes = Content.propTypes

export default Content
